export const SyntaxCase = {
    camelCase: "camelCase",
    humanCase: "Human Case",
};

export default {
    /**
     * Takes a string and changes it's current syntax to a new one
     * @param {String} str The string to transform
     * @param {String} fromSyntax The current syntax of the string
     * @param {String} toSyntax The desired syntax of the string
     * @returns A new string with the transfomred syntax
     */
    changeSyntax(str, fromSyntax, toSyntax) {
        if (fromSyntax == SyntaxCase.camelCase && toSyntax == SyntaxCase.humanCase)
            return fromCamelCaseToHumanCase(str);

        throw `Syntax conversion from "${fromSyntax}" to "${toSyntax}" has not been specified.`;
    },
};

const fromCamelCaseToHumanCase = (str) => {
    return str
        .replace(/([A-Z])/g, ' $1')// insert a space before all caps
        .replace(/^./, function (str) { return str.toUpperCase(); }) // uppercase the first character
}
